import { createEntityAdapter } from '@reduxjs/toolkit';

import type { ApiIntegration } from './types';

const entityAdapter = createEntityAdapter<ApiIntegration>();

const INITIAL_STATE = {
  apiIntegrations: entityAdapter.getInitialState(),
};

export { INITIAL_STATE };
